import type { PropostaItem } from '@/types'
import type { ComboData, ComboValue } from './types'

export function calculateComboValues(combos: ComboData[], itens: PropostaItem[]): ComboValue[] {
  return combos.map((combo) => {
    const items = itens.filter((item) => combo.itemIds.includes(item.id))
    const subtotal = items.reduce((acc, item) => acc + item.total, 0)
    const descontoValor = subtotal * (combo.desconto / 100)

    return {
      ...combo,
      items,
      subtotal,
      descontoValor,
      total: subtotal - descontoValor,
    }
  })
}

export function calculateComboDiscountTotal(comboValues: ComboValue[]): number {
  return comboValues.reduce((acc, combo) => acc + combo.descontoValor, 0)
}
